import $ from 'jquery';
import { cssAnimation2 } from '../../util/animate-css.js';
import { Dropdown } from '../../modules/components/dropdown.js';
// import mpro from './mpro.init';

// Assign global jq objects
let $W = null;
let $D = null;
let $B = null;
let $UI = null;
let UI_SELECTOR = null;

/**
 * @returns {JQuery<window>}
 */
mpro.get$W = function() {
	if (!$W) {
		$W = $(window);
	}
	return $W;
};

/**
 * @returns {JQuery<HTMLBodyElement>}
 */
mpro.get$B = function() {
	if (!$B) {
		$B = $(document.body);
	}
	return $B;
};

/**
 * @returns {JQuery<HTMLDocument>}
 */
mpro.get$D = function() {
	if (!$D) {
		$D = $(document);
	}
	return $D;
};

/**
 * @returns {JQuery}
 */
mpro.getUI = function() {
	if (!$UI) {
		$UI = $(UI_SELECTOR);
	}
	return $UI;
};

/**
 * @param {string|HTMLElement|JQuery} selector
 */
mpro.setUI = function(selector) {
	if (selector instanceof $) {
		$UI = selector;
	}
	else {
		UI_SELECTOR = String(selector);
	}
};

mpro.getUiNavbarTop = () => {
	return $(mpro.config.ui.navbar_top_selector);
};

mpro.getUiMenubar = () => {
	return $(mpro.config.ui.menubar_selector);
};

/**
 * Return the the overlay container in which the element is located, if any
 * @param {JQuery<Partial<HTMLElement>> | Partial<HTMLElement>} $element
 */
mpro.getOverlayContainer = ($element) => {

	/** @type {JQuery} */ // @ts-ignore
	const $elem = $element.jquery ? $element : $($element);

	return $elem.closest('[data-overlay-type]');
};

/**
 * Check wether the element is inside an overlay
 * @param {JQuery<Partial<HTMLElement>> | Partial<HTMLElement>} $element
 */
mpro.isInOverlay = $element => mpro.getOverlayContainer($element).length > 0;

// Allow animation to trigger after the element has been added to the DOM
mpro.reflow = function(element) {
	// Access the getComputedStyle() in order for the client to trigger a reflow
	// https://stackoverflow.com/questions/24148403/trigger-css-transition-on-appended-element
	// return window.getComputedStyle(element).transform;
	return $(element).css('transform');
	// Used by bs5
	// https://www.charistheo.io/blog/2021/02/restart-a-css-animation-with-javascript/#restarting-a-css-animation
	// return element.offsetHeight;
};

/**
 * @param {{ top?: number; bottom?: number; left?: number; right?: number; }} threshold
 */
mpro.viewport = (threshold = {}) => {

	const thresholdTop = threshold.top || 0;
	const thresholdLeft = threshold.left || 0;
	const thresholdBottom = threshold.bottom || 0;
	const thresholdRight = threshold.right || 0;

	if (!('innerWidth' in window)) {

		/** @type {HTMLElement} */ // @ts-ignore
		const view = document.scrollingElement || document.documentElement || document.body;

		return {
			view,
			prefix: 'client',
			top: view.scrollTop + thresholdTop,
			left: view.scrollLeft + thresholdLeft,
			bottom: view.scrollTop + view.clientHeight - thresholdBottom,
			right: view.scrollLeft + view.clientWidth - thresholdRight,
			width: view.clientWidth - thresholdLeft - thresholdRight,
			height: view.clientHeight - thresholdTop - thresholdBottom,
		};
	}

	return {
		view: window,
		prefix: 'inner',
		top: window.pageYOffset,
		left: window.pageXOffset,
		bottom: window.pageYOffset + window.innerHeight,
		right: window.pageXOffset + window.innerWidth,
		width: window.innerWidth,
		height: window.innerHeight,
	};
};

mpro.isOverflownY = function(element) {
	return element.scrollHeight > element.clientHeight;
};

mpro.getVisibleFixedHeader = function() {

	let $elements = $('*').filter(function() {
		const jqThis = $(this);
		const css = jqThis.css(['position', 'height', 'visibility', 'display', 'opacity', 'top']);

		return (
			(css.position === 'fixed') &&
			(Number.parseFloat(css.height) > 0) &&
			(css.visibility === 'visible') &&
			(css.display !== 'none') &&
			(Number.parseFloat(css.opacity) !== 0) &&
			(Number.parseFloat(css.top) < 20)
		);
	});

	// Keep only the one with the tallest height
	if ($elements.length > 1) {
		let tallestId = 0;
		let tallestHeight = 0;
		$elements = $elements.each(function(i, v) {
			const thisHeight = $(this).height();
			if (thisHeight > tallestHeight) {
				tallestId = i;
				tallestHeight = thisHeight;
			}
		});
		$elements = $elements.eq(tallestId);
	}

	return $elements;
};

/**
 * @param {Partial<HTMLElement>} elem
 * @param {HTMLElement} relativeParent
 */
mpro.getRelativeOffset = function(elem, relativeParent, removeScrollOffset = false) {
	if (!relativeParent) {
		relativeParent = document.documentElement;
	}
	const offset = { left: elem.offsetLeft || 0, top: elem.offsetTop || 0 };
	while ((elem = elem.offsetParent) && (elem !== relativeParent)) {
		if (!Number.isNaN(Number(elem.offsetTop))) {
			offset.left += elem.offsetLeft;
			offset.top += elem.offsetTop;
		}
	}

	// Remove the scroll offset
	// The operation must be an 'addition'
	if (removeScrollOffset) {
		offset.left += relativeParent.scrollLeft;
		offset.top += relativeParent.scrollTop;
	}

	return offset;
};

mpro.getRelativeOffsetLeft = function(elem, relativeParent) {
	return mpro.getRelativeOffset(elem, relativeParent).left;
};

mpro.getRelativeOffsetTop = function(elem, relativeParent) {
	return mpro.getRelativeOffset(elem, relativeParent).top;
};

mpro.getDocScrollPos = function() {
	if (document.scrollingElement) {
		const scr = document.scrollingElement;
		return [scr.scrollLeft, scr.scrollTop];
	}

	return [0, 0];

};

/** @param {JQuery} $elem */
const getOffsetParentTop = ($elem) => {
	const $parent = $elem.closest('[data-scroll-offset-parent]');
	if ($parent.length > 0) {
		const selector = $parent.data('scroll-offset-parent');
		const $target = selector ? $(selector) : $parent;
		const topOffset = $target[0] ? mpro.getRelativeOffsetTop($target[0]) : 0;
		const height = $target.outerHeight() || 0;
		return topOffset + height;
	}
	return 0;
};

/**
 * @param {JQuery} $element
 * @param {{ type?: 'focus' | 'success' | 'error'; duration?: number; delay?: number; }} options
 */
mpro.showFocusAnimation = function($element, options = {}) {
	const {
		type = 'focus',
		...opt
	} = options;
	return $.when(...$element.map((_, el) => cssAnimation2(el, `scroll-target-${type}`, [], {
		duration: 800,
		...opt,
	})));
};

/**
 * @param {JQuery | HTMLElement} element
 * @param {{ speed?: number|'fast'|'slow'; focusMiddle?: boolean; focusMiddleX?: boolean; offsetY?: number|string; blink?: boolean; blinkType?: 'focus' | 'success' | 'error'; container?: JQuery<HTMLElement>|HTMLElement; ifNeeded?: boolean; }=} options
 */
mpro.scrollToElement = function(element, options = {}) {

	/** @type {JQuery} */ // @ts-ignore
	const $element = element.jquery ? element : $(element);

	// @ts-ignore
	let $containerScrollingElement = options.container ? $(options.container) : $element.closest('div.fancy-content, div.offcanvas-body, div.modal-body');
	if ($containerScrollingElement.length === 0) {
		// @ts-ignore
		$containerScrollingElement = $(document.scrollingElement || 'html,body');
	}

	try {
		const SCR = $containerScrollingElement[0];
		const containerIsRoot = (SCR === document.scrollingElement) || (SCR === document.documentElement) || (SCR === document.body);
		let speed = ('speed' in options) ? options.speed : 166;
		const focusMiddle = ('focusMiddle' in options) ? Boolean(options.focusMiddle) : true;
		const focusMiddleX = ('focusMiddleX' in options) ? Boolean(options.focusMiddleX) : false;
		const offsetY = ('offsetY' in options) ? Number.parseInt(options.offsetY.toString(), 10) : (containerIsRoot ? getOffsetParentTop($element) : 0);
		const blink = ('blink' in options) ? Boolean(options.blink) : false;
		const blinkType = ('blinkType' in options) ? options.blinkType : 'focus';
		const ifNeeded = ('ifNeeded' in options) ? Boolean(options.ifNeeded) : true;
		const elem = $element[0];

		const getScrollTo = (getX = true, getY = true) => {
			let scrollLeft;
			let scrollTop;

			if (focusMiddle) {
				const offset = mpro.getRelativeOffset(elem, $containerScrollingElement[0], false);
				if (getX) {
					scrollLeft = focusMiddleX ? Math.max(0, (offset.left + elem.offsetWidth / 2) - SCR.clientWidth / 2) : 0;
				}
				if (getY) {
					scrollTop = Math.max(0, (offset.top + elem.offsetHeight / 2) - SCR.clientHeight / 2 - mpro.getUiNavbarTop().height() / 2);
				}
			}
			else {
				if (getX) {
					scrollLeft = 0;
				}
				if (getY) {
					// Also take into account the header
					const offset = mpro.getRelativeOffset(elem, $containerScrollingElement[0], false);
					scrollTop = offset.top - (offsetY || 0);
				}
			}

			const props = {};

			if (getX) {
				props.scrollLeft = scrollLeft + 'px';
			}

			if (getY) {
				props.scrollTop = scrollTop + 'px';
			}

			return props;
		};

		// End current animation
		$containerScrollingElement.finish();

		// Do not animate if we don't have to
		if (window.matchMedia('(prefers-reduced-motion)').matches === true) {
			speed = 0;
		}

		// Is smooth-scrolling is enabled, we must temporarily disabled it to not conflict with our custom animation
		const scrollBehavior = $containerScrollingElement.css('scrollBehavior');
		if (scrollBehavior === 'smooth') {
			$containerScrollingElement.css('scrollBehavior', 'auto');
		}

		// Only if not already into view
		// ? Note: The browser (Chrome) will force-scroll to the target element
		// ? ONLY from a previous navigation (not on refresh or manual url - this must be a valid element click).
		// ? Note2: the default browser 'smooth' animation is already disabled by the 'scrollBehavior' property above
		// ? in order to capture the final scrolling position of the element. No way around this.
		if (ifNeeded && mpro.isElementInViewport($element, $containerScrollingElement, true, { top: offsetY })) {

			// Re-enable smooth scrolling
			if (scrollBehavior === 'smooth') {
				$containerScrollingElement.css('scrollBehavior', '');
			}

			// Blink the element
			if (blink) {
				mpro.showFocusAnimation($element, { type: blinkType });
			}

			return $containerScrollingElement;
		}

		// const recalcPropSteps = [
		// 	// { name: '_fx_proc_q5_', step: .5 }, // -> not working
		// 	// { name: '_fx_proc_q8_', step: .8 }, // -> not working
		// 	{ name: '_fx_proc_q10_', step: 1 },
		// ];

		const props = getScrollTo();
		elem.style.setProperty('--animation-delay', `${speed}ms`);
		$containerScrollingElement.animate(props, {
			duration: speed,
			// progress(animPromise, progress/* , remainingMs */) {

			// 	console.log('progress', progress);

			// 	for (const { name, step } of recalcPropSteps) {

			// 		if ((progress >= step) && (typeof this[name] === 'undefined')) {

			// 			// Recalculate scroll offset (in case the layout changes)
			// 			const reCalcProps = Object.create(null);
			// 			for (const [k, v] of Object.entries(getScrollTo())) {
			// 				if (animPromise.props[k] !== v) {
			// 					reCalcProps[k] = v;
			// 				}
			// 			}

			// 			// eslint-disable-next-line unicorn/prefer-ternary
			// 			if (Object.keys(reCalcProps).length > 0) {
			// 				this[name] = reCalcProps;
			// 				// console.log(`Progress ${step * 100}%: %o, prop name: %o, animPromise: %o`, progress, this[name], animPromise);
			// 			}
			// 			// No recalculation is necessary
			// 			else {
			// 				this[name] = true;
			// 			}

			// 			// Stop prop iteration
			// 			break;
			// 		}
			// 	}
			// },
			// step(now, tween) {
			// 	for (const { name, step } of recalcPropSteps) {

			// 		if (this[name] && (this[name] !== true)) {

			// 			if ((tween.prop in this[name]) && (this[name][tween.prop] !== true)) {
			// 				// Set the new prop
			// 				tween.end = Number.parseFloat(this[name][tween.prop]);
			// 				// Flag as completed
			// 				this[name][tween.prop] = true;
			// 				// console.log(`Step ${step * 100}%:`, 'prop', tween.prop, 'now', now, '_fx_proc_q5_', this._fx_proc_q5_, '_fx_proc_q9_', this._fx_proc_q9_, 'tween', tween);
			// 			}

			// 			let allSet = true;
			// 			for (const k in this[name]) {
			// 				if (this[name][k] !== true) {
			// 					allSet = false;
			// 				}
			// 			}

			// 			if (allSet === true) {
			// 				this[name] = true;
			// 			}
			// 		}
			// 	}
			// },
			complete() {
				// Remove custom props
				// for (const { name } of recalcPropSteps) {
				// 	delete this[name];
				// }

				// Remove the animation-delay
				elem.style.removeProperty('--animation-delay');

				// Re-enable smooth scrolling
				if (scrollBehavior === 'smooth') {
					$containerScrollingElement.css('scrollBehavior', '');
				}

				// Blink the element
				if (blink) {
					// // animateFilterJQ($element, { contrast: 2, opacity: 0.3, grayscale: 0.5 }, { duration: 133 }, { duration: 266 });
					// $element.prop('faPropDelay', 0);
					// $element.finish().animate({ faPropDelay: 1 }, {
					// 	duration: 66,
					// 	complete: () => {
					// 		$element.removeProp('faPropDelay');
					// 		setTimeout(() => {
					// 			animateFilterJQ($element, { contrast: 1.5, opacity: 0.3, grayscale: 0.5 }, { duration: 66 }, { duration: 333 });
					// 		});
					// 	},
					// });

					mpro.showFocusAnimation($element, { type: blinkType });
				}
			},
		});
	}
	catch (error) {
		console.warn('Error scrolling to element', $element, options, error);
	}

	// Allow chaining
	return $containerScrollingElement;
};

/**
 * @param {number} scrollToX
 * @param {number} scrollToY
 * @param {{ speed?: number|'fast'|'slow'; }} options
 */
mpro.scrollToPos = function(scrollToX, scrollToY, options = {}) {

	/** @type {JQuery} */
	// @ts-ignore
	const $containerScrollingElement = $(document.scrollingElement || 'html, body');
	const speed = ('speed' in options) ? options.speed : 'fast';

	try {

		// End current animation
		$containerScrollingElement.finish();

		const props = {
			scrollLeft: scrollToX + 'px',
			scrollTop: scrollToY + 'px',
		};

		// Do not animate if we don't have to
		if (window.matchMedia('(prefers-reduced-motion)').matches === true) {
			$containerScrollingElement.prop(props);
		}
		// Use animations
		else {

			// Is smooth-scrolling is enabled, we must temporarily disabled it to
			const scrollBehavior = $containerScrollingElement.css('scrollBehavior');
			if (scrollBehavior === 'smooth') {
				$containerScrollingElement.css('scrollBehavior', 'auto');
			}

			$containerScrollingElement.animate(props, {
				duration: speed,
				complete: () => {
					// Re-enable smooth scrolling
					if (scrollBehavior === 'smooth') {
						$containerScrollingElement.css('scrollBehavior', '');
					}
				},
			});
		}
	}
	catch (error) {
		console.warn('Error scrolling to position [%o, %o]', scrollToX, scrollToY, options, error);
	}

	return $containerScrollingElement;
};

/**
 *
 * @param {(HTMLElement | Window)=} elem
 */
mpro.getScrollingContainer = function(elem) {
	try {
		// @ts-ignore
		if ((elem === window) || (elem === document.scrollingElement) || (elem.scrollHeight !== elem.clientHeight)) {
			return elem;
		}
		// @ts-ignore
		if (!elem || !elem.parentElement) {
			return window;
		}
		// @ts-ignore
		return mpro.getScrollingContainer(elem.parentElement);
	}
	catch (error) {
		console.warn('Error in getScrollingContainer()', error);
		return window;
	}
};

/**
 *
 * @param {HTMLElement|JQuery} $element
 * @param {HTMLElement|JQuery=} $viewportElement
 */
mpro.isElementInViewport = function($element, $viewportElement, fullyInView = true, threshold = {}) {

	const thresholdTop = threshold.top || 0;
	const thresholdLeft = threshold.left || 0;
	const thresholdBottom = threshold.bottom || 0;
	const thresholdRight = threshold.right || 0;

	// Check if in parent viewport
	if ($viewportElement) {

		/** @type {HTMLElement} */
		// @ts-ignore
		const element = ($element.jquery ? $element[0] : $element);
		/** @type {HTMLElement} */
		// @ts-ignore
		const viewportElement = ($viewportElement.jquery ? $viewportElement[0] : $viewportElement);
		const elemOffset = mpro.getRelativeOffset(element, viewportElement);

		const elemRect = {
			top: elemOffset.top,
			left: elemOffset.left,
			// Also take into account that the viewport might be smaller in height than the element's height
			bottom: elemOffset.top + Math.min(element.offsetHeight, viewportElement.clientHeight),
			// Also take into account that the viewport might be smaller in width than the element's width
			right: elemOffset.left + Math.min(element.offsetWidth, viewportElement.clientWidth),
		};

		const viewRect = {
			top: viewportElement.scrollTop + thresholdTop,
			left: viewportElement.scrollLeft + thresholdLeft,
			bottom: viewportElement.scrollTop + viewportElement.clientHeight - thresholdBottom,
			right: viewportElement.scrollLeft + viewportElement.clientWidth - thresholdRight,
		};

		// Fully in view
		if (fullyInView) {
			return (
				elemRect.top >= viewRect.top &&
				elemRect.left >= viewRect.left &&
				elemRect.bottom <= viewRect.bottom &&
				elemRect.right <= viewRect.right
			);
		}

		// Partially in view
		return (
			elemRect.top <= viewRect.bottom &&
			elemRect.bottom >= viewRect.top &&
			elemRect.left <= viewRect.right &&
			elemRect.right >= viewRect.left
		);
	}

	// @ts-ignore
	const rect = ($element.jquery ? $element[0] : $element).getBoundingClientRect();
	const viewport = mpro.viewport();

	// Fully in view
	if (fullyInView) {
		return (
			// getBoundingClientRect() returns values relative to the viewport
			rect.top >= thresholdTop &&
			rect.left >= thresholdLeft &&
			rect.bottom <= (viewport.bottom - thresholdBottom) &&
			rect.right <= (viewport.right - thresholdRight)
		);
	}

	// Partially in view
	return (
		rect.top <= (viewport.bottom - thresholdBottom) &&
		rect.bottom >= thresholdTop &&
		rect.left <= (viewport.right - thresholdRight) &&
		rect.right >= thresholdLeft
	);
};

/**
 *
 * @param {JQuery|HTMLElement} $container
 * @param {JQuery|HTMLElement} $element
 * @param {boolean} fullyInView
 */
mpro.isElementInView = ($container, $element, fullyInView = true) => {

	/** @type {HTMLElement} */
	// @ts-ignore
	const container = ($container.jquery ? $container[0] : $container);
	/** @type {HTMLElement} */
	// @ts-ignore
	const element = ($element.jquery ? $element[0] : $element);

	const containerScrollTop = container.scrollTop;
	const containerScrollLeft = container.scrollLeft;
	const containerHeight = container.clientHeight;
	const containerWidth = container.clientWidth;
	const elementTop = element.offsetTop;
	const elementLeft = element.offsetLeft;
	const wholeElemHeight = (fullyInView === true) ? element.offsetHeight : 0;
	const wholeElemWidth = (fullyInView === true) ? element.offsetWidth : 0;

	if (
		// Check top
		((elementTop + wholeElemHeight) >= containerScrollTop) &&
		// Check bottom (take into account that the viewport might be smaller than the element)
		((elementTop + wholeElemHeight) <= (containerScrollTop + Math.max(containerHeight, wholeElemHeight))) &&
		// Check left
		((elementLeft + wholeElemWidth) >= containerScrollLeft) &&
		// Check right (take into account that the viewport might be smaller than the element)
		((elementLeft + wholeElemWidth) <= (containerScrollLeft + Math.max(containerWidth, wholeElemWidth)))
	) {
		return true;
	}

	return false;
};

mpro.toggleExpandedBlock = function(raInstance, prefix, toggleCallback) {

	const jKey = raInstance.refs.$contextElement.closest('tr').data('key');
	const $container = $(`#${prefix}${jKey}`);

	if (jKey != null && $container.length > 0) {
		$container.remove();
		toggleCallback && toggleCallback.call(this, 'collapse', raInstance.refs.$contextElement, $container);
		return false;
	}

	toggleCallback && toggleCallback.call(this, 'expand', raInstance.refs.$contextElement, $container);

	return true;
};

mpro.closeDropdowns = () => {
	// Close bs/popper dropdowns
	Dropdown.clearMenus();
	// Close select2 dropdowns
	$('.select2-container--open').each(function() {
		$(this).siblings('select').select2('close');
	});
};

/**
 * Close tooltips/popovers
 */
mpro.closeSimpleOverlays = () => {
	mpro.removeTooltips && mpro.removeTooltips();
	mpro.removePopovers && mpro.removePopovers();
	mpro.closeDropdowns();
};

/**
 * Close all notifications
 */
mpro.closeAllNotifications = (withTransition = false) => {
	mpro.clearToasts && mpro.clearToasts({ type: 'notification' }, withTransition);
};

/**
 * Close tooltips/popovers/toasts/modals/dialogs/drawers
 */
mpro.closeAllOverlays = () => {
	// Close tooltips/popovers
	mpro.closeSimpleOverlays();
	// Close all other overlays
	mpro.closeAllNotifications();
	mpro.closeAllModals && mpro.closeAllModals();
	mpro.closeAllDrawers && mpro.closeAllDrawers();
	mpro.closeAllDialogs && mpro.closeAllDialogs();
	// mpro.closeAllFancyboxes && mpro.closeAllFancyboxes();
};

/**
 * @param {JQuery} $container
 * @param {string} selector
 */
mpro.resolveLazyContent = ($container, selector = 'template[data-lazy-content]') => {

	/** @type {JQuery<HTMLTemplateElement>} */ // @ts-ignore
	const $template = $container.find(selector);

	if ($template.length === 0) {
		return;
	}

	/** @type {JQuery} */ // @ts-ignore
	const $fragmentNode = $($template[0].content.cloneNode(true)).children();
	const $context = $fragmentNode.wrapAll('<div/>').parent();

	// Transfer attributes
	const attr = {};
	for (const value of $template[0].attributes) {
		attr[value.name] = value.value;
	}
	$context.attr(attr);

	// @ts-ignore
	$template.replaceWith($context);

	// Enhance the content with js bindings
	mpro.initStatics($context);
};

// ===================================
// Set ui selector now
// ===================================
mpro.setUI(mpro.config.ui.selector);
// ===================================

export default mpro;
